import React from 'react'

/**
 * 공개 홍보·소개 면에 대한 광고·준법·심의 고지(이용 안내). 법률 자문이 아닙니다.
 * @param {{ scope?: 'personal'|'category', density?: 'full'|'compact', className?: string }} props
 */
export default function PublicPromoComplianceNotice({ scope = 'personal', density = 'full', className = '' }) {
  const base = 'border border-amber-200/90 bg-amber-50 text-amber-950 leading-relaxed shadow-sm'

  if (density === 'compact') {
    return (
      <div className={`${base} mb-3 rounded-xl px-3.5 py-3 text-xs sm:text-[13px] ${className}`} role="note">
        <div className="text-sm font-bold text-amber-950">광고·준법·심의(심의필)</div>
        <p className="mt-2 text-amber-950/95">
          공개 문구·이미지·버튼 문구는 <span className="font-semibold">이용자(설계사·소속사) 책임</span>입니다. 상담 유도·보장·사례 소개 등으로{' '}
          <span className="font-semibold">금융상품 광고 또는 업무광고</span>에 해당할 수 있으면,{' '}
          <span className="font-semibold">게시 전 소속사 준법감시인 확인·광고 심의</span>를 거치고{' '}
          <span className="font-semibold">심의필·유효기간 등 표기</span>를 소속사 안내대로 해 주세요. 템플릿·예시 문구는 참고용이며 검토를 대신하지 않습니다.
        </p>
      </div>
    )
  }

  const surfaceLabel = scope === 'category' ? '홍보용페이지' : '소개페이지'
  const material =
    scope === 'category'
      ? '공개하는 문구·이미지·설문·상담 신청 폼·버튼 문구 등'
      : '공개하는 문구·이미지·버튼·상담 유도 문구 등'

  return (
    <div className={`${base} rounded-xl px-4 py-4 text-sm sm:px-5 sm:py-4 sm:text-[15px] ${className}`} role="note">
      <div className="text-base font-bold tracking-tight text-amber-950 sm:text-lg">
        금융상품 광고·준법·심의(심의필) 안내
      </div>
      <p className="mt-3 text-amber-950/95">
        설계EZ는 <span className="font-semibold">{surfaceLabel} 레이아웃·기능</span>만 제공합니다. {material}이{' '}
        <span className="font-semibold">금융소비자보호법 등에 따른 금융상품 광고·업무광고</span>에 해당할 수 있는 경우,
        <strong className="font-semibold text-amber-950"> 게시·배포 전에 반드시 소속사(또는 법령상 책임이 있는 주체)의 준법감시인 확인·내부 광고 심의 절차를 마친 뒤</strong> 공개해야 합니다.
      </p>
      <p className="mt-2 text-amber-950/95">
        <span className="font-semibold">심의필 번호·유효기간·면책 문구</span> 등 표시 의무가 있다면 이용자가 직접 반영해야 하며, 아래{' '}
        <span className="font-semibold">「광고 심의필」</span> 섹션에 소속사가 정한 형식으로 입력하는 것을 권장합니다. 본 안내는 법률 자문이 아니며, 최종 판단은 준법·법무와 상의해 주세요.
      </p>
    </div>
  )
}
